// extracted by mini-css-extract-plugin
export default {"tenantLogo":"I4y9A___NotableTenants-module__tenantLogo","title":"D0BMD___NotableTenants-module__title","container":"_35WCd___NotableTenants-module__container"};